import React from "react";
import style from "./style.module.scss";
import { LCButton, LCTooltip } from "../../frameWork";
import {
	BUTTON_SHAPE,
	BUTTON_SIZE,
	DOWNLOAD_ICON_FA_FA,
	DOWNLOAD_TOOLTIP,
} from "../../../appConstants";

export const DownloadButton = (props) => {
	return (
		<LCTooltip title={DOWNLOAD_TOOLTIP}>
			<LCButton
				className={style.downloadButton}
				onClick={props.onClick}
				shape={BUTTON_SHAPE}
				// icon={DOWNLOAD_ICON_FA_FA}
				size={BUTTON_SIZE}
				loading={props.loading}
                buttonlabel={!props.loading &&<i className={DOWNLOAD_ICON_FA_FA}></i>}
			/>
		</LCTooltip>
	);
};
